var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-scrollload"},[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.onVisibilityChange),expression:"onVisibilityChange"}],staticClass:"content-scrollload-bar"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }